import React from "react"
import HorizontalField from "../HorizontalField/HorizontalField"
import {InterestTerms} from "../../resources/account"
import {ShowMoreParagraph} from "../ShowMoreParagraph/ShowMoreParagraph"

export default function InterestViewer({interestTerms}: {interestTerms: InterestTerms}) {
	return (
		<div className="interest-viewer">
			<HorizontalField label="Interest Mode" fieldClassName={"vertical-field "} useLabelTitle={true}>
				{interestTerms.enableCustomerInterestFormula ? "Non-Split" : "Proportional"}
			</HorizontalField>

			<HorizontalField label="Calculation Formula" fieldClassName={"vertical-field "} useLabelTitle={true}>
				{interestTerms.enableCustomerInterestFormula
					? interestTerms.customerInterestFormula
					: interestTerms.interestFormula}
			</HorizontalField>

			{!interestTerms.enableCustomerInterestFormula && (
				<div className="interest-row-container">
					<HorizontalField label="Interest Rate" fieldClassName={"vertical-field "} useLabelTitle={true}>
						{interestTerms.interestRate}%
					</HorizontalField>

					<HorizontalField label="Customer Share" fieldClassName={"vertical-field "} useLabelTitle={true}>
						{interestTerms.customerInterestShare}%
					</HorizontalField>
				</div>
			)}

			<HorizontalField
				label="Customer Interest Rate"
				fieldClassName={"vertical-field with-border-bottom"}
				useLabelTitle={true}
			>
				{interestTerms.customerInterestRate}%
			</HorizontalField>

			<HorizontalField label="Disclaimer" fieldClassName={"vertical-field "} useLabelTitle={true}></HorizontalField>
			<ShowMoreParagraph
				summary={<p>The interest information displayed here is a snapshot based on the current interest setup.</p>}
			>
				<p>
					Please note that the actual interest payout is determined by an end-of-month calculation, which may vary
					depending on the configured interest modes and fluctuations in federal rates throughout the month.
				</p>
			</ShowMoreParagraph>
		</div>
	)
}
